import BaseDialog from '@/components/ui/BaseDialog';
import { HISTORY_TYPE, RfuSummary, SUMMARY_TITLE, SummaryDialogProps } from '@/types/pages/storeManagement/history';
import { useTranslation } from 'react-i18next';
import PpContent from './PpContent';
import RfuContent from './RfuContent';

const SummaryDialog = ({ open, type, summaryInfo, jobId, onClose, onExited }: SummaryDialogProps) => {
    const { t } = useTranslation('common');
    return (
        <BaseDialog
            dialogTitle={t(String(SUMMARY_TITLE[type]))}
            open={open}
            showTopRightClose
            confirmButtonText=""
            cancelButtonText=""
            onClose={onClose}
            TransitionProps={{
                onExited,
            }}
            sx={{
                width: '100%',
            }}
        >
            {type === HISTORY_TYPE.PP && <PpContent jobId={jobId as string} />}
            {type === HISTORY_TYPE.RFU && <RfuContent summaryInfo={summaryInfo as RfuSummary} />}
        </BaseDialog>
    );
};

export default SummaryDialog;
